module.exports = __webpack_public_path__ + "static/media/glance-simple.8e3bb0c0.svg";